import { Box } from "@mui/material";
import { ChangeEvent, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ExpandMore } from "@mui/icons-material";
import { MenuItem } from "@/components";
import { SelectProps } from "../../types";
import StyledTextField from "./i18next-select.styled";

const I18nSelect = ({ variant = "light" }: SelectProps) => {
  const { t, i18n } = useTranslation("languages-list");
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || "en");
  const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
    await i18n.changeLanguage(e.target.value);
    setSelectedLanguage(e.target.value);
  };

  const supportedLanguages = useMemo(() => Object.keys((i18n.getDataByLanguage("en") || {})["languages-list"]), [i18n]);
  if (supportedLanguages.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        gridRow: "3",
        minWidth: variant === "dark" ? "fit-content" : "160px",
      }}
    >
      <StyledTextField
        select
        size="small"
        variant="outlined"
        name="language-select"
        onChange={handleChange}
        SelectProps={{ IconComponent: ExpandMore }}
        fullWidth
        value={selectedLanguage}
        data-testid="i18n-select"
        dark={variant === "dark" ? 1 : 0}
      >
        {supportedLanguages.map((language) => (
          <MenuItem key={language} value={language} data-testid={`language-select-option-${language}`}>
            {t(language)}
          </MenuItem>
        ))}
      </StyledTextField>
    </Box>
  );
};

export default I18nSelect;
